// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth_form__qaka4 {
  margin: 20px 0;
}
.auth_form__qaka4 .auth_formGroup__hVNC\\+ {
  margin-bottom: 12px;
  position: relative;
}
.auth_form__qaka4 .auth_eyeIcon__19fAv {
  cursor: pointer;
  background-color: red;
}
.auth_form__qaka4 .auth_signUpBtn__rbbIm,
.auth_form__qaka4 .auth_signInBtn__OqcVQ,
.auth_form__qaka4 .auth_skipBtn__2nCpB {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 12px 0;
}
.auth_form__qaka4 .auth_signUpBtn__rbbIm .auth_forgotPassword__9Jrjl,
.auth_form__qaka4 .auth_signInBtn__OqcVQ .auth_forgotPassword__9Jrjl,
.auth_form__qaka4 .auth_skipBtn__2nCpB .auth_forgotPassword__9Jrjl {
  font: var(--body-font-two);
  color: var(--primary-color);
  cursor: pointer;
}
.auth_form__qaka4 .auth_signUpBtn__rbbIm button,
.auth_form__qaka4 .auth_signInBtn__OqcVQ button,
.auth_form__qaka4 .auth_skipBtn__2nCpB button {
  min-width: 120px;
  min-height: 42px;
  text-transform: capitalize;
  box-shadow: unset;
}
.auth_form__qaka4 .auth_signUpBtn__rbbIm.auth_signInBtn__OqcVQ, .auth_form__qaka4 .auth_signUpBtn__rbbIm.auth_skipBtn__2nCpB,
.auth_form__qaka4 .auth_signInBtn__OqcVQ.auth_signInBtn__OqcVQ,
.auth_form__qaka4 .auth_signInBtn__OqcVQ.auth_skipBtn__2nCpB,
.auth_form__qaka4 .auth_skipBtn__2nCpB.auth_signInBtn__OqcVQ,
.auth_form__qaka4 .auth_skipBtn__2nCpB.auth_skipBtn__2nCpB {
  justify-content: space-between;
}
.auth_form__qaka4 .auth_or__Pw04b {
  width: 100%;
  height: 1px;
  background-color: #e5e5e5;
  margin: 20px 0;
  position: relative;
}
.auth_form__qaka4 .auth_or__Pw04b p {
  font: var(--body-font-three);
  color: #8692a4;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-transform: capitalize;
  background-color: #faf4f2;
  padding: 0px 10px;
  text-align: center;
}
.auth_form__qaka4 .auth_socialLoginBtns__NUyDv {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;
}
.auth_form__qaka4 .auth_socialLoginBtns__NUyDv button {
  min-height: 36px;
  box-shadow: unset;
  text-transform: capitalize;
  font: var(--body-font-three);
  font-weight: 500;
}
.auth_form__qaka4 .auth_socialLoginBtns__NUyDv button img,
.auth_form__qaka4 .auth_socialLoginBtns__NUyDv button svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
}

.auth_forgotPwSection__QZAHW .auth_formContainer__TKnxy .auth_titleContainer__Tfy1e {
  margin-bottom: 5px;
}

@media (max-width: 991px) {
  .auth_form__qaka4 {
    margin: 15px 0;
  }
  .auth_form__qaka4 .auth_formGroup__hVNC\\+ {
    margin-bottom: 10px;
  }
  .auth_form__qaka4 .auth_signUpBtn__rbbIm,
  .auth_form__qaka4 .auth_signInBtn__OqcVQ,
  .auth_form__qaka4 .auth_skipBtn__2nCpB {
    margin: 10px 0;
  }
  .auth_form__qaka4 .auth_signUpBtn__rbbIm button,
  .auth_form__qaka4 .auth_signInBtn__OqcVQ button,
  .auth_form__qaka4 .auth_skipBtn__2nCpB button {
    min-width: 120px;
    min-height: 30px;
  }
  .auth_form__qaka4 .auth_or__Pw04b {
    margin: 20px 0;
  }
  .auth_form__qaka4 .auth_or__Pw04b p {
    font-size: 12px;
  }
  .auth_form__qaka4 .auth_socialLoginBtns__NUyDv {
    margin-top: 20px;
    gap: 10px;
  }
}
@media (max-width: 767px) {
  .auth_form__qaka4 .auth_signUpBtn__rbbIm button,
  .auth_form__qaka4 .auth_signInBtn__OqcVQ button,
  .auth_form__qaka4 .auth_skipBtn__2nCpB button {
    min-height: 38px;
    min-width: unset;
  }
}
.auth_container__li8dy {
  display: flex;
  flex-direction: column;
}
.auth_container__li8dy form {
  display: flex;
  flex-direction: column;
}
.auth_container__li8dy button {
  margin: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/auth/auth.module.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;AACD;AACC;EACC,mBAAA;EACA,kBAAA;AACF;AAEC;EACC,eAAA;EACA,qBAAA;AAAF;AAGC;;;EAGC,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AADF;AAGE;;;EACC,0BAAA;EACA,2BAAA;EACA,eAAA;AACH;AAEE;;;EACC,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;AAEH;AACE;;;;;EAEC,8BAAA;AAIH;AAAC;EACC,WAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AAEF;AAAE;EACC,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAEH;AAEC;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAAF;AAEE;EACC,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,4BAAA;EACA,gBAAA;AAAH;AAEG;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;AAAJ;;AAQE;EACC,kBAAA;AALH;;AAUA;EACC;IACC,cAAA;EAPA;EASA;IACC,mBAAA;EAPD;EAUA;;;IAGC,cAAA;EARD;EAUC;;;IACC,gBAAA;IACA,gBAAA;EANF;EAUA;IACC,cAAA;EARD;EAUC;IACC,eAAA;EARF;EAYA;IACC,gBAAA;IACA,SAAA;EAVD;AACF;AAcA;EAKG;;;IACC,gBAAA;IACA,gBAAA;EAdF;AACF;AAoBA;EACC,aAAA;EACA,sBAAA;AAlBD;AAmBC;EACC,aAAA;EACA,sBAAA;AAjBF;AAoBC;EACC,cAAA;AAlBF","sourcesContent":[".form {\r\n\tmargin: 20px 0;\r\n\r\n\t.formGroup {\r\n\t\tmargin-bottom: 12px;\r\n\t\tposition: relative;\r\n\t}\r\n\r\n\t.eyeIcon {\r\n\t\tcursor: pointer;\r\n\t\tbackground-color: red;\r\n\t}\r\n\r\n\t.signUpBtn,\r\n\t.signInBtn,\r\n\t.skipBtn {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: flex-end;\r\n\t\talign-items: center;\r\n\t\tmargin: 12px 0;\r\n\r\n\t\t.forgotPassword {\r\n\t\t\tfont: var(--body-font-two);\r\n\t\t\tcolor: var(--primary-color);\r\n\t\t\tcursor: pointer;\r\n\t\t}\r\n\r\n\t\tbutton {\r\n\t\t\tmin-width: 120px;\r\n\t\t\tmin-height: 42px;\r\n\t\t\ttext-transform: capitalize;\r\n\t\t\tbox-shadow: unset;\r\n\t\t}\r\n\r\n\t\t&.signInBtn,\r\n\t\t&.skipBtn {\r\n\t\t\tjustify-content: space-between;\r\n\t\t}\r\n\t}\r\n\r\n\t.or {\r\n\t\twidth: 100%;\r\n\t\theight: 1px;\r\n\t\tbackground-color: #e5e5e5;\r\n\t\tmargin: 20px 0;\r\n\t\tposition: relative;\r\n\r\n\t\tp {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: #8692a4;\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 50%;\r\n\t\t\tleft: 50%;\r\n\t\t\ttransform: translate(-50%, -50%);\r\n\t\t\ttext-transform: capitalize;\r\n\t\t\tbackground-color: #faf4f2;\r\n\t\t\tpadding: 0px 10px;\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\t}\r\n\r\n\t.socialLoginBtns {\r\n\t\tmargin-top: 25px;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tjustify-content: center;\r\n\t\tgap: 15px;\r\n\r\n\t\tbutton {\r\n\t\t\tmin-height: 36px;\r\n\t\t\tbox-shadow: unset;\r\n\t\t\ttext-transform: capitalize;\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tfont-weight: 500;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.forgotPwSection {\r\n\t.formContainer {\r\n\t\t.titleContainer {\r\n\t\t\tmargin-bottom: 5px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t.form {\r\n\t\tmargin: 15px 0;\r\n\r\n\t\t.formGroup {\r\n\t\t\tmargin-bottom: 10px;\r\n\t\t}\r\n\r\n\t\t.signUpBtn,\r\n\t\t.signInBtn,\r\n\t\t.skipBtn {\r\n\t\t\tmargin: 10px 0;\r\n\r\n\t\t\tbutton {\r\n\t\t\t\tmin-width: 120px;\r\n\t\t\t\tmin-height: 30px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.or {\r\n\t\t\tmargin: 20px 0;\r\n\r\n\t\t\tp {\r\n\t\t\t\tfont-size: 12px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.socialLoginBtns {\r\n\t\t\tmargin-top: 20px;\r\n\t\t\tgap: 10px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.form {\r\n\t\t.signUpBtn,\r\n\t\t.signInBtn,\r\n\t\t.skipBtn {\r\n\t\t\tbutton {\r\n\t\t\t\tmin-height: 38px;\r\n\t\t\t\tmin-width: unset;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Vendor staff signup\r\n.container {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tform {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t}\r\n\r\n\tbutton {\r\n\t\tmargin: 0.5rem;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `auth_form__qaka4`,
	"formGroup": `auth_formGroup__hVNC+`,
	"eyeIcon": `auth_eyeIcon__19fAv`,
	"signUpBtn": `auth_signUpBtn__rbbIm`,
	"signInBtn": `auth_signInBtn__OqcVQ`,
	"skipBtn": `auth_skipBtn__2nCpB`,
	"forgotPassword": `auth_forgotPassword__9Jrjl`,
	"or": `auth_or__Pw04b`,
	"socialLoginBtns": `auth_socialLoginBtns__NUyDv`,
	"forgotPwSection": `auth_forgotPwSection__QZAHW`,
	"formContainer": `auth_formContainer__TKnxy`,
	"titleContainer": `auth_titleContainer__Tfy1e`,
	"container": `auth_container__li8dy`
};
export default ___CSS_LOADER_EXPORT___;
